import { createElement } from "@/utils/create-elem.js";
import { themeBtn, bestBtn, soundsBtn } from "./ToolsBar.js";

import "@/styles/style.scss";

export function Header(parent) {
  const header = createElement({
    tag: "header",
    classes: ["header"],
    parent: parent,
  });

  createElement({
    tag: "h1",
    text: "Nonograms",
    parent: header,
  });

  const tools = createElement({
    tag: "div",
    classes: ["tools"],
    parent: header,
  });

  themeBtn(tools);
  bestBtn(tools);
  soundsBtn(tools);
}
